/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Nolpusers3Inputs */

const en_coinvestments_share_nolpusers3 = /** @type {(inputs: Coinvestments_Share_Nolpusers3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users found for this organisation.`)
};

/**
* | output |
* | --- |
* | "No users found for this organisation." |
*
* @param {Coinvestments_Share_Nolpusers3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_nolpusers3 = /** @type {((inputs?: Coinvestments_Share_Nolpusers3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Nolpusers3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_nolpusers3(inputs)
});
export { coinvestments_share_nolpusers3 as "coInvestments_share_noLpUsers" }